// src/pages/ActivateAccount.js
import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

// Material UI bileşenleri
import {
  Container,
  Card,
  CardContent,
  Typography,
  CircularProgress,
  Box,
} from "@mui/material";

const ActivateAccount = () => {
  const { token } = useParams();
  const [activationStatus, setActivationStatus] = useState({
    loading: true,
    message: "",
  });

  // Aktivasyon isteğinin sadece bir kez yapılması için ref
  const activationAttemptedRef = useRef(false);

  useEffect(() => {
    const activateAccount = async () => {
      try {
        const response = await axios.get(`https://bakapps.site/auth/activate/${token}`);

        if (response.status === 200) {
          setActivationStatus({
            loading: false,
            message: "Hesabınız başarıyla aktive edilmiştir.",
          });
        }
      } catch (error) {
        console.error("Activation error:", error);
        setActivationStatus({
          loading: false,
          message:
            "Aktivasyon başarısız oldu. Token geçersiz ya da süresi dolmuş olabilir.",
        });
      }
    };

    // Aktivasyon isteğini yalnızca bir defa yapıyoruz
    if (!activationAttemptedRef.current && token) {
      activationAttemptedRef.current = true;
      activateAccount();
    }
  }, [token]);

  return (
    <Container maxWidth="sm" sx={{ py: 5 }}>
      <Card sx={{ boxShadow: 3 }}>
        <CardContent>
          <Typography variant="h5" gutterBottom>
            Hesap Aktivasyonu
          </Typography>
          {activationStatus.loading ? (
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, mt: 2 }}>
              <CircularProgress />
              <Typography>Hesabınız aktive ediliyor, lütfen bekleyin...</Typography>
            </Box>
          ) : (
            <Typography sx={{ mt: 2 }}>{activationStatus.message}</Typography>
          )}
        </CardContent>
      </Card>
    </Container>
  );
};

export default ActivateAccount;
